import { useEffect, useState } from 'react';

export interface SubscriptionAccessBannerState {
    bannerVisible: boolean;
    subscriptionNotActive: boolean;
}

export const useSubscriptionAccessBanner = (
    loggedIn: boolean,
    hasAccess: boolean,
    displayDelayMs: number,
): SubscriptionAccessBannerState => {
    const subscriptionNotActive = loggedIn && !hasAccess;
    const [bannerVisible, setBannerVisible] = useState(false);

    useEffect(() => {
        setBannerVisible(false);

        if (!subscriptionNotActive)
            return;

        const bannerTimer = window.setTimeout(() => setBannerVisible(true), displayDelayMs);
        return () => window.clearTimeout(bannerTimer);
    }, [displayDelayMs, subscriptionNotActive]);

    return { bannerVisible, subscriptionNotActive };
};
